export default "__VITE_ASSET__CPYffXFq__"